import type { GarmentGeometry } from '@seddi/scene';

import type { SceneRenderable } from '../renderables/sceneRenderable';
import type { ResourcesContext } from '../resources/resourcesContext';
import type { StitchesTextures } from '../resources/stitchesTexturesTypes';
import type { TSceneEntityEx, TSceneEx } from '../scene/sceneTypes';
import type { Theme } from '../theme/themeTypes';
import type { SceneReconcilerConfig } from './sceneReconcilerConfig';

export type SceneReconcilerFrameEntity = {
  childrenDiff: { prev?: TSceneEntityEx; next: TSceneEntityEx }[];
  data: TSceneEntityEx;
  isGeometryDirty?: boolean;
  isPiece?: boolean;
};

export type SceneReconcilerFrame = {
  readonly config: SceneReconcilerConfig;
  readonly entities: Map<string, SceneReconcilerFrameEntity>;
  garmentGeometry?: GarmentGeometry;
  nextParent?: TSceneEntityEx;
  nextScene?: TSceneEx;
  prevParent?: TSceneEntityEx;
  prevScene?: TSceneEx;
  readonly resources: ResourcesContext;
  readonly scene: SceneRenderable;
  showGarmentGeometry?: boolean;
  stitchesTextures?: StitchesTextures;
  readonly theme: Theme;
};

/**
 * Create.
 * @param config - Config.
 * @param resources - Resources context.
 * @param scene - Scene renderable.
 * @param theme - Theme.
 */
export const create = (
  config: SceneReconcilerConfig,
  resources: ResourcesContext,
  scene: SceneRenderable,
  theme: Theme,
): SceneReconcilerFrame => {
  return { config, entities: new Map(), resources, scene, theme };
};

/**
 * Reset.
 * @param frame - Frame.
 */
export const reset = (frame: SceneReconcilerFrame) => {
  frame.entities.clear();
  frame.garmentGeometry = undefined;
  frame.nextScene = undefined;
  frame.prevScene = undefined;
  frame.showGarmentGeometry = false;
  frame.stitchesTextures = undefined;
};
